<template>
	<v-content>
		<v-navigation-drawer
			v-model="drawer"
			fixed 
			clipped
			width="290"
			class="white"
			app>
			<div class="text-xs-center py-3">
				<v-btn round color="primary" @click="openCreate()" dark>Crea Evento</v-btn>
			</div>
			<v-date-picker
				v-model="today"
				color="primary"
				locale="it"
				class="elevation-0"
				reactive
				no-title
				@change="getEvents()"
				@input="getEvents()"
			></v-date-picker>
			<v-layout column wrap px-4>
				<v-subheader class="pl-0">Calendari disponibili</v-subheader>
				<v-checkbox label="Seleziona tutti" class="mt-0" color="primary" hide-details ripple v-model="selectAll"></v-checkbox>
				<v-divider class="my-2"></v-divider>
				<template v-for="(calendar, c) in calendars">
					<v-checkbox :label="calendar.name" class="mt-0" :color="calendar.color" hide-details ripple v-model="selectedCalendars" :value="calendar.id" :key="c"></v-checkbox>
				</template>
			</v-layout>
		</v-navigation-drawer>

		<v-toolbar
			class="elevation-0 toolbar-calendar"
			color="white"
			fixed
			app
			clipped-left
			v-if="$store.getters.isAuthenticated">
			<v-toolbar-title class="grey--text text--darken-3">
				<v-toolbar-side-icon @click.native="drawer = !drawer">
				</v-toolbar-side-icon>
				<span class="title ml-3 mr-5"><span class="fw400">Simona&Simona</span></span>			
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-tooltip bottom>
				<v-btn flat icon color="primary" @click="$router.back()" slot="activator" dark><v-icon>arrow_back</v-icon></v-btn>
				<span>Indietro</span>
			</v-tooltip>  
			<v-tooltip bottom>
				<v-btn outline color="grey lighten-1" @click="setToday()" slot="activator">Oggi</v-btn>
				<span>Oggi</span>
			</v-tooltip>   
			<v-btn @click="prev()" icon>
				<v-icon color="grey darken-2">keyboard_arrow_left</v-icon>
			</v-btn>
			<v-btn @click="next()" icon>
				<v-icon color="grey darken-2">keyboard_arrow_right</v-icon>
			</v-btn>
			<v-menu v-if="!drawer"
				ref="menu"
				v-model="currentDateMenu"
				:nudge-right="40"
				lazy
				transition="scale-transition"
				offset-y
				full-width
				max-width="290px"
				min-width="290px">
				<v-text-field
					slot="activator"
					readonly flat solo
					background-color="grey lighten-4"
					append-icon="arrow_drop_down"
					:value="formatCurrentMonth"
					hide-details
				></v-text-field>
				<v-date-picker
					v-model="today"
					locale="It"
					scrollable
					color="primary"
					@change="getEvents()"
					@input="getEvents()">
				</v-date-picker>
			</v-menu>
			<v-text-field v-else
				readonly flat solo
				background-color="grey lighten-4"
				:value="formatCurrentMonth"
				hide-details
			></v-text-field>
			<v-spacer></v-spacer>
			<v-spacer></v-spacer>
			<v-spacer></v-spacer>
			<v-spacer></v-spacer>
			<v-spacer></v-spacer>
			<v-spacer></v-spacer>
			<v-spacer></v-spacer>
			<v-spacer></v-spacer>
			<v-progress-circular
				v-show="loadEvents"
				indeterminate
				color="primary"
				:width="3"
			></v-progress-circular>
			<v-spacer></v-spacer>
			<v-select
				v-model="type"
				:items="typeOptions"
				label="Tipo"
				dense
				background-color="grey lighten-4"
				hide-details
				flat solo
			></v-select>
		</v-toolbar>

		<v-container fluid fill-height pa-0>
			<v-layout wrap>
				<v-flex xs12 fill-height>
					<v-calendar
						ref="calendar"
						:now="today"
						v-model="today"
						color="primary"
						:type="type"
						locale="It"
						:short-intervals="true"
						:first-interval="13"
						:interval-count="30"
						:interval-format="intervalFormat"
						:show-interval-label="showIntervalLabel"
						:interval-height="45"
						:interval-minutes="30"
						:class="{'open-nav': drawer}"
						>
						<template
							slot="dayLabel"
							slot-scope="{ date, day }"
							>
							<div class="monthly-label-day">{{ day }}</div>
						</template>
						<template
							slot="dayMonth"
							slot-scope="{ date, day }"
							>
							<span></span>
						</template>
						<template
							slot="day"
							slot-scope="{ date }"
							:hasTime="true"
							>
							<template v-for="(event, n) in events[date]">
								<v-menu 
									:key="event.id"
									v-model="eventMenu[event.id]"
									full-width
									offset-x
									lazy
									max-width="400px"
									:close-on-content-click="false"
									>
									<div
										slot="activator"
										v-ripple
										class="my-event"
										v-if="n < maxMonthlyEventDisplay"
										>
										<div class="monthly-event">
											<div class="monthly-event-point" :style="{'border-color': event.calendar.color}"></div>
										</div>
										<span class="monthly-event-title">
											<span class="monthly-event-title-started-at">{{ formatMonthlyEventDate(event.start_time) }}</span>
											<span class="monthly-event-title-summary">{{ event.name }}</span>
										</span>
									</div>
									<v-card
										color="grey lighten-4"
										min-width="350px"
										flat
										>
										<v-toolbar
											color="white"
											flat
											:elevation="0"
											dense
											>
											<v-spacer></v-spacer>
											<v-tooltip bottom>
												<v-btn icon @click="openEdit(event)" slot="activator">
													<v-icon class="fs20i">edit</v-icon>
												</v-btn>
												<span>Modifica</span>
											</v-tooltip>
											<v-btn icon @click="deleteEvent(event.id)">
												<v-icon class="fs20i">delete</v-icon>
											</v-btn>
											<v-tooltip bottom>
												<v-btn icon @click="eventMenu[event.id] = false" slot="activator">
													<v-icon class="fs20i">close</v-icon>
												</v-btn>
												<span>Chiudi</span>
											</v-tooltip>
										</v-toolbar>
										<v-list two-line dense class="pa-0 pb-3">
											<v-list-tile>
												<v-list-tile-avatar>
													<div class="monthly-event-menu-pin" :style="{'background-color': event.calendar.color}"></div>
												</v-list-tile-avatar>
												<v-list-tile-content>
													<v-list-tile-title>{{ event.name }}</v-list-tile-title>
													<v-list-tile-sub-title class="capitalize">{{ formatEventDate(event.started_at, event.ended_at, event.start_time, event.end_time) }}</v-list-tile-sub-title>
												</v-list-tile-content>
											</v-list-tile>
											<v-list-tile>
												<v-list-tile-action>
													<v-icon color="primary">people</v-icon>
												</v-list-tile-action>
												<v-list-tile-content>
													<v-list-tile-title>Cliente</v-list-tile-title>
													<v-list-tile-sub-title>{{ event.customername }}</v-list-tile-sub-title>
												</v-list-tile-content>
											</v-list-tile>
											<v-list-tile>
												<v-list-tile-action>
													<v-icon color="primary">today</v-icon>
												</v-list-tile-action>
												<v-list-tile-content>
													<v-list-tile-title>Calendario</v-list-tile-title>
													<v-list-tile-sub-title>{{ event.calendar.name }}</v-list-tile-sub-title>
												</v-list-tile-content>
											</v-list-tile>
											<v-list-tile>
												<v-list-tile-action>
													<v-icon color="primary">local_offer</v-icon>
												</v-list-tile-action>
												<v-list-tile-content>
													<v-list-tile-title>Trattamenti</v-list-tile-title>
													<v-list-tile-sub-title>
														<v-chip v-for="(product, p) in event.products" :key="p" small>{{ product.name }}</v-chip>
													</v-list-tile-sub-title>
												</v-list-tile-content>
											</v-list-tile>
											<v-list-tile v-if="event.description">
												<v-list-tile-action>
													<v-icon color="primary">note</v-icon>
												</v-list-tile-action>
												<v-list-tile-content>
													<v-list-tile-title>Descrizione</v-list-tile-title>
													<v-list-tile-sub-title>{{ event.description }}</v-list-tile-sub-title>
												</v-list-tile-content>
											</v-list-tile>
										</v-list>
									</v-card>
								</v-menu>
							</template>
							<v-menu v-if="events[date] && events[date].length > maxMonthlyEventDisplay" 
								v-model="groupEventMenu[date]"
								full-width
								bottom
								lazy
								:close-on-content-click="false"
								origin="center center"
								transition="scale-transition"
								>
								<div
									slot="activator"
									v-ripple
									class="my-event monthly-event-others"
								> altri	{{ events[date].length - maxMonthlyEventDisplay }}
								</div>
								<v-card
									class="pa-3"
									color="white"
									max-width="250px"
									flat
									>
									<div class="pb-2">
										<div class="monthly-event-others-menu-container">
											<div class="monthly-event-others-menu-day">{{ dateToDayString(date) }}</div>
											<div class="monthly-event-others-menu-dayn">{{ dateToDayNumber(date) }}</div>
										</div>
									</div>
									<template v-for="(ev, ei) in events[date]">
										<v-menu 
											:key="ei"
											v-model="subEventMenu[ev.id]"
											full-width
											offset-x
											lazy
											max-width="400px"
											:close-on-content-click="false"
											>
											<div
												slot="activator"
												v-ripple
												class="my-event"
												>
												<div class="monthly-event">
													<div class="monthly-event-point" :style="{'border-color': ev.calendar.color}"></div>
												</div>
												<span class="monthly-event-title">
													<span class="monthly-event-title-started-at">{{ formatMonthlyEventDate(ev.start_time) }}</span>
													<span class="monthly-event-title-summary">{{ ev.name }}</span>
												</span>
											</div>
											<v-card
												color="grey lighten-4"
												min-width="350px"
												flat
												>
												<v-toolbar
													color="white"
													flat
													:elevation="0"
													dense
													>
													<v-spacer></v-spacer>
													<v-tooltip bottom>
														<v-btn icon @click="openEdit(ev)" slot="activator">
															<v-icon class="fs20i">edit</v-icon>
														</v-btn>
														<span>Modifica</span>
													</v-tooltip>
													<v-btn icon @click="deleteEvent(ev.id)">
														<v-icon class="fs20i">delete</v-icon>
													</v-btn>
													<v-tooltip bottom>
														<v-btn icon @click="subEventMenu[ev.id] = false" slot="activator">
															<v-icon class="fs20i">close</v-icon>
														</v-btn>
														<span>Chiudi</span>
													</v-tooltip>
												</v-toolbar>
												<v-list two-line dense class="pa-0 pb-3">
													<v-list-tile>
														<v-list-tile-avatar>
															<div class="monthly-event-menu-pin" :style="{'background-color': ev.calendar.color}"></div>
														</v-list-tile-avatar>
														<v-list-tile-content>
															<v-list-tile-title>{{ ev.name }}</v-list-tile-title>
															<v-list-tile-sub-title class="capitalize">{{ formatEventDate(ev.started_at, ev.ended_at, ev.start_time, ev.end_time) }}</v-list-tile-sub-title>
														</v-list-tile-content>
													</v-list-tile>
													<v-list-tile>
														<v-list-tile-action>
															<v-icon color="primary">today</v-icon>
														</v-list-tile-action>
														<v-list-tile-content>
															<v-list-tile-title>Calendario</v-list-tile-title>
															<v-list-tile-sub-title>{{ ev.calendar.name }}</v-list-tile-sub-title>
														</v-list-tile-content>
													</v-list-tile>
													<v-list-tile v-if="ev.description">
														<v-list-tile-action>
															<v-icon color="primary">note</v-icon>
														</v-list-tile-action>
														<v-list-tile-content>
															<v-list-tile-title>Descrizione</v-list-tile-title>
															<v-list-tile-sub-title>{{ ev.description }}</v-list-tile-sub-title>
														</v-list-tile-content>
													</v-list-tile>
												</v-list>
											</v-card>
										</v-menu>
									</template>
								</v-card>
							</v-menu>
						</template>

						<!-- <template
							slot="dayHeader"
							slot-scope="{ date }">
							<template v-for="(event, n) in events[date]">

								<div
									v-if="!event.started_at"
									:key="event.id"
									class="event-weekday"
									@click="open(event)"
									v-html="event.name"
								></div>
							</template>
						</template> -->
							<!-- the events at the bottom (timed) -->
						<template
							slot="dayBody"
							slot-scope="{ date, timeToY, minutesToPixels }">
							<template v-for="event in events[date]">
								<!-- timed events -->
								<v-menu 
									:key="event.id"
									v-model="eventMenu[event.id]"
									full-width
									offset-x
									lazy
									max-width="400px"
									:close-on-content-click="false"
									>
									<div
										v-if="event.started_at"
										slot="activator"
										:key="event.id"
										:style="{
											top: timeToY(event.start_time) + 'px',
											height: minutesToPixels(event.duration_minutes) + 'px',
											background: event.calendar.color,
											width: event.size + '%',
											left: event.position + '%'
										}"
										class="event-week-day"
										@click=""
									>
										<div class="event-week-day-title">
											<span class="event-week-day-summary">{{ event.name }}</span>
										</div>
										<div class="event-week-day-time">
											<span style="white-space: normal; overflow-wrap: break-word;">
												{{ formatTimeFromTo(event.start_time, event.end_time) }}
											</span>
										</div>
									</div>
									<v-card
										color="grey lighten-4"
										min-width="350px"
										flat
										>
										<v-toolbar
											color="white"
											flat
											:elevation="0"
											dense
											>
											<v-spacer></v-spacer>
											<v-tooltip bottom>
												<v-btn icon @click="openEdit(event)" slot="activator">
													<v-icon class="fs20i">edit</v-icon>
												</v-btn>
												<span>Modifica</span>
											</v-tooltip>
											<v-btn icon @click="deleteEvent(event.id)">
												<v-icon class="fs20i">delete</v-icon>
											</v-btn>
											<v-tooltip bottom>
												<v-btn icon @click="eventMenu[event.id] = false" slot="activator">
													<v-icon class="fs20i">close</v-icon>
												</v-btn>
												<span>Chiudi</span>
											</v-tooltip>
										</v-toolbar>
										<v-list two-line dense class="pa-0 pb-3">
											<v-list-tile>
												<v-list-tile-avatar>
														<div class="monthly-event-menu-pin" :style="{'background-color': event.calendar.color}"></div>
												</v-list-tile-avatar>
												<v-list-tile-content>
													<v-list-tile-title>{{ event.name }}</v-list-tile-title>
													<v-list-tile-sub-title class="capitalize">{{ formatEventDate(event.started_at, event.ended_at, event.start_time, event.end_time) }}</v-list-tile-sub-title>
												</v-list-tile-content>
											</v-list-tile>
											<v-list-tile>
												<v-list-tile-action>
													<v-icon color="primary">people</v-icon>
												</v-list-tile-action>
												<v-list-tile-content>
													<v-list-tile-title>Cliente</v-list-tile-title>
													<v-list-tile-sub-title>{{ event.customername }}</v-list-tile-sub-title>
												</v-list-tile-content>
											</v-list-tile>
											<v-list-tile>
												<v-list-tile-action>
													<v-icon color="primary">today</v-icon>
												</v-list-tile-action>
												<v-list-tile-content>
													<v-list-tile-title>Calendario</v-list-tile-title>
													<v-list-tile-sub-title>{{ event.calendar.name }}</v-list-tile-sub-title>
												</v-list-tile-content>
											</v-list-tile>
											<v-list-tile>
												<v-list-tile-action>
													<v-icon color="primary">local_offer</v-icon>
												</v-list-tile-action>
												<v-list-tile-content>
													<v-list-tile-title>Trattamenti</v-list-tile-title>
													<v-list-tile-sub-title>
														<v-chip v-for="(product, p) in event.products" :key="p" small>{{ product.name }}</v-chip>
													</v-list-tile-sub-title>
												</v-list-tile-content>
											</v-list-tile>
											<v-list-tile v-if="event.description">
												<v-list-tile-action>
													<v-icon color="primary">note</v-icon>
												</v-list-tile-action>
												<v-list-tile-content>
													<v-list-tile-title>Descrizione</v-list-tile-title>
													<v-list-tile-sub-title>{{ event.description }}</v-list-tile-sub-title>
												</v-list-tile-content>
											</v-list-tile>
										</v-list>
									</v-card>
								</v-menu>
							</template>
						</template>
					</v-calendar>
				</v-flex>
			</v-layout>
		</v-container>
		<v-fab-transition>
			<v-btn
				@click="openCreate()"
				v-model="fab"
				:loading="saved"
				color="primary"
				dark
				fab
				fixed
				bottom
				right>
				<v-icon>add</v-icon>
				<v-icon>close</v-icon>
			</v-btn>
		</v-fab-transition>

		<v-dialog
			lazy
			v-model="openDialog"
			max-width="650">
			<v-card class="flex pa-0">
				<v-toolbar flat color="grey lighten-4">
					<v-toolbar-title class="pl-3 grey--text text--darken-4">Nuovo Evento</v-toolbar-title>
					<v-spacer></v-spacer>
				</v-toolbar>
				<v-divider></v-divider>
				<v-container fluid px-2 pb-0>
					<fields-generator
						:layoutClass="['row','wrap']" 
						:fieldsset.sync="fieldsset"
						:model="model"
						ref="fieldsgenerator"
					></fields-generator>
					<small class="pl-4">* Indica i campi obbligatori</small>
				</v-container>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="red" flat @click.native="closeDialog">Chiudi</v-btn>
					<v-btn color="primary" :loading="saved" flat @click.native="save">Salva</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-content>					
</template>

<script>

import Vue from 'vue'
import FieldsGenerator from '@/components/FieldsGenerator'

export default {
	name: 'my-calendar',
	components: {
		FieldsGenerator,
	},
	data: () => ({
		drawer: null,
		today: moment().format('YYYY-MM-DD'),
		type: JSON.parse(localStorage.getItem('calendar_type')) ? JSON.parse(localStorage.getItem('calendar_type')) : 'month',
		fab: false,
		openDialog: false,
		model: {},
		fieldsset: {},
		saved: false,
		events: [],
		currentDateMenu: false,
		typeOptions: [
			{ text: 'Giorno', value: 'day' },
			{ text: '4 Giorni', value: '4day' },
			{ text: 'Settimana', value: 'week' },
			{ text: 'Mese', value: 'month' },
		],
		calendars: [],
		selectedCalendars:[],
		selectAll: false,
		eventMenu: {},
		subEventMenu: {},
		groupEventMenu: {},
		edit: false,
		maxMonthlyEventDisplay: null,
		loadEvents: false,

	}),

	mounted () {
		window.addEventListener('resize', () => {this.maxMonthlyEventDisplay = this.calcMonthlyEventDisplay}, { passive: true })
		this.maxMonthlyEventDisplay = this.calcMonthlyEventDisplay
	},

	created() {
		this.axios.get('events-info').then(response => {
			// get body data
			this.fieldsset = response.data.fields
			this.calendars = response.data.fields.calendars
			this.presetSelectedCalendars()
			//this.getEvents()
		},
		response => {
			// error callback
		})
	},

	watch: {
		selectAll: {
			handler(newValue, oldValue) {
				localStorage.setItem('selected_calendars', JSON.stringify([]))
				if(newValue) {
					_.forEach(this.calendars, (calendar) => {
						if(!this.selectedCalendars.includes(calendar.id)) {
							this.selectedCalendars.push(calendar.id)
						}
					})
				} else {
					this.selectedCalendars = []
				}
			}
		},

		selectedCalendars: {
			handler(newValue, oldValue) {
				localStorage.setItem('selected_calendars', JSON.stringify(this.selectedCalendars))
				this.getEvents()
			}
		},

		type: {
			handler(newValue, oldValue) {
				localStorage.setItem('calendar_type', JSON.stringify(this.type))
				this.getEvents()
			}
		},
	},

	computed: {
			
		formatCurrentMonth() {
			let month = moment(this.today).format('MMMM')
			return month.charAt(0).toUpperCase() + month.slice(1)
		},

		formatEventDate(started_at, ended_at, start_time, end_time) {
			return (started_at, ended_at, start_time, end_time) => {
				return moment(started_at).format("dddd, D MMMM") + ' ⋅ ' + moment(start_time, 'hh:mm').format('h:mmA') + ' - ' + moment(end_time, 'hh:mm').format('h:mmA')
			}
		},

		formatMonthlyEventDate(started_at) {
			return (started_at) => {
				return moment(started_at, 'hh:mm').format('h:mmA')
			}
		},

		dateToDayNumber(date) {
			return (date) => {
				return moment(date).format('D')
			}
		},

		dateToDayString(date) {
			return (date) => {
				return moment(date).format('ddd')
			}
		},

		dateToTimeString(date) {
			return (date) => {
				return moment(date).format('HH:mm')
			}
		},

		formatTimeFromTo(start_time, end_time) {
			return (start_time, end_time) => {
				let start_date_format = 'h:mmA'
				let end_date_format = 'h:mmA'
				if(moment(start_time, 'hh:mm').format('h:mm').endsWith(':00')) {
					start_date_format = 'hA'
				}
				if(moment(end_time, 'hh:mm').format('h:mm').endsWith(':00')) {
					end_date_format = 'hA'
				}
				return moment(start_time, 'hh:mm').format(start_date_format) + ' – ' + moment(end_time, 'hh:mm').format(end_date_format)
			}
		},

		calcMonthlyEventDisplay () {
      		switch (this.$vuetify.breakpoint.name) {
				case 'xs': return 1
				case 'sm': return 1
				case 'md': return 2
				case 'lg': return 3
				case 'xl': return 4
      		}
    	}
	},

	methods: {
		intervalFormat(interval) {
			return interval.time
		},

		showIntervalLabel(interval) {
			return interval.time
		},

		presetSelectedCalendars() {
			if(localStorage.getItem('selected_calendars') != '[]') {
				if(JSON.parse(localStorage.getItem('selected_calendars')).length == this.calendars.length) {
					this.selectedCalendars = []
					this.selectAll = true
				} else {
					this.selectedCalendars = JSON.parse(localStorage.getItem('selected_calendars'))
				}
			}
		},

		prev() {
			this.$refs.calendar.prev()
			this.getEvents()
		},

		next() {
			this.$refs.calendar.next()
			this.getEvents()
		},

		calcIntervalDate() {
      		switch (this.type) {
				case 'month':
					this.from = moment(this.today).startOf('month').subtract(6, 'd').format('YYYY-MM-DD HH:mm')
					this.to = moment(this.today).endOf('month').add(6, 'd').format('YYYY-MM-DD HH:mm')
					break

				case 'week':
					this.from = moment(this.today).day("Sunday").format('YYYY-MM-DD HH:mm')
					this.to = moment(this.today).day("Saturday").format('YYYY-MM-DD HH:mm')
					break

				case '4day':
					this.from = moment(this.today).subtract(3, 'd').format('YYYY-MM-DD HH:mm')
					this.to = moment(this.today).add(3, 'd').format('YYYY-MM-DD HH:mm')
					break

				case 'day':
				 	this.from = moment(this.today).format('YYYY-MM-DD HH:mm')
					this.to = moment(this.today).format('YYYY-MM-DD HH:mm')
					break
      		}
		},

		getEvents() {
			this.events = []
			this.loadEvents = true
			this.calcIntervalDate()

			let options = {
				from: this.from,
				to: this.to,
				calendars: this.selectedCalendars,
				calendar_type: this.type
			}
			this.axios.post('events-filters', {'subFilters': options}).then(response => {
				// get body data
				this.events = response.data.data
				this.loadEvents = false
				this.$store.commit('endProgress')
			},
			response => {
				// error callback
			})
		},

		setToday() {
			if(this.today !=  moment().format('YYYY-MM-DD')) {
				this.today = moment().format('YYYY-MM-DD')
				this.getEvents()
			}
		},

		closeDialog() {
			this.openDialog = false
			this.model = {}
		},

		openEdit(event) {
			Object.assign(this.model, event)
			this.openDialog = true
			this.edit = true
		},

		openCreate() {
			this.openDialog = true
			let nowRound = 15 - moment().minute() % 15
			this.model.start_time = moment().add(nowRound, 'm').format('HH:mm')
			this.model.end_time = moment().add(1, 'h').add(nowRound, 'm').format('HH:mm')
			this.model.started_at = moment().format('YYYY-MM-DD')
		},

		deleteEvent(id) {
			this.axios.post('events/delete', { ids: [id] }).then(response => {
				// get body data
				let data = response.data
				this.getEvents()
				this.confirmDelete = false
				let snackmessage = ''
				let snackcolor = ''
				if (data.status == 'message') {
					snackmessage = data.message
					snackcolor = data.type
				} else {
					snackmessage = 'Elementi eliminati con successo.'
					snackcolor = 'success'
				}
				this.$store.commit('setSnackbar', {
					timeout: 6000,
					text: snackmessage,
					value: true,
					color: 'success'
				})
			},
			response => {
				// error callback
			})
		},

		save() {
			this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
				if (!result) {
					return false
				}
				this.saved = true
				if(this.edit){
					this.axios.put('events/' + this.model.id, this.model).then(response => {
						// get body data
						this.model = {}
						this.saved = false
						this.closeDialog()
						this.getEvents()
						this.edit = false
					},
					response => {
						// error callback
					})
				} else {
					this.axios.post('events', this.model).then(response => {
						// get body data
						this.model = {}
						this.saved = false
						this.closeDialog()
						this.getEvents()
					},
					response => {
						// error callback
					})
				}
			}).catch(() => {

			})
		}
			
	}
}
</script>

<style>
	.my-event {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		border-radius: 2px;
		font-size: 12px;
		padding: 3px;
		cursor: pointer;
		margin-bottom: 1px;
		left: 4px;
		margin-right: 8px;
		display: flex;
		width: 100%;
	}
	.my-event:hover {
		background: rgba(0,0,0,0.04);
	}
	.event-week {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		border-radius: 2px;
		color: #ffffff;
		border-radius: 4px;
		border: 1px solid white;
		font-size: 12px;
		padding: 3px;
		cursor: pointer;
		margin-bottom: 1px;
		left: 4px;
		margin-right: 8px;
		display: flex;
		width: 100%;
	}
	.event-week-day {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		border-radius: 2px;
		background-color: #1867c0;
		color: #ffffff;
		border-radius: 4px;
		border: 1px solid white;
		font-size: 12px;
		padding: 3px;
		cursor: pointer;
		margin-bottom: 1px;
		left: 4px;
		margin-right: 8px;
		position: absolute;
		right: 4px;
		margin-right: 0px;
	}
	.event-week-day-title {
		white-space: normal;
		overflow-wrap: break-word;
		word-wrap: break-word;
		color: #fff;
		letter-spacing: .1px;
	}
	.event-week-day-summary {
		font-weight: 500;
		white-space: normal;
		overflow-wrap: break-word;
		color: #fff;
		font-size: 12px;
		text-align: left;
		line-height: 15px;
	}
	.event-week-day-time {
		max-width: 100%;
		white-space: nowrap;
		display: flex;
		color: rgb(255, 255, 255);
		letter-spacing: 0.1px;
		font-size: 12px;
		line-height: 15px;
		overflow: hidden;
		-webkit-font-smoothing: antialiased;
	}
	.v-calendar-weekly__head-weekday, .v-calendar-weekly__day-month {
		text-transform: capitalize
	}
	.v-date-picker-header__value > .primary--text > button {
		text-transform: capitalize
	}
	.toolbar-calendar > .v-toolbar__content {
		border-bottom: 1px solid #E0E0E0;
	}
	.v-list--two-line.v-list--dense .v-list__tile {
    	height: 54px !important;
	}
	.monthly-event {
		display: -webkit-box;
		display: -moz-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-align-items: center;
		align-items: center;
		-webkit-box-flex: none;
		-webkit-flex: none;
		flex: none;
		-webkit-justify-content: center;
		justify-content: center;
		margin-right: 6px;
	}
	.monthly-event-point {
		border-radius: 8px;
		border: 4px solid;
		height: 0;
		width: 0;
	}
	.monthly-event-title {
		-webkit-align-items: center;
		align-items: center;
		display: -webkit-box;
		display: -moz-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		overflow: hidden;
	}
	.monthly-event-title-started-at {
		margin-right: 4px;
		font-weight: 400;
	}
	.monthly-event-title-summary {
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-flex: 0 1 auto;
		-webkit-flex: 0 1 auto;
		flex: 0 1 auto;
		white-space: nowrap;
		font-weight: 500;
	}
	.monthly-event-others {
		color: #3c4043;
		font-weight: 700;
	}
	.monthly-event-others-menu-container {
		margin: 0 auto;
		text-align: center;
	}
	.monthly-event-others-menu-day {
		color: #70757a;
		font-size: 11px;
		letter-spacing: .8px;
		text-transform: uppercase;
	}
	.monthly-event-others-menu-dayn {
		color: #fff;
		background-color: #1a73e8;
		font-size: 24px;
		font-size: 26px;
		letter-spacing: -2.6px;
		text-indent: -2.6px;
		font-variant: tabular-nums;
		font-family: 'Google Sans',Roboto,Arial,sans-serif;
		font-weight: 400;
		line-height: 36px;
		width: 36px;
		-webkit-border-radius: 50%;
		border-radius: 50%;
		height: 36px;
		cursor: pointer;
		outline: none;
		margin: auto
	}
	.monthly-event-menu-pin {
		border-radius: 4px;
		height: 16px;
		width: 16px;
		margin-left: 3px;
		margin-right: 21px;
		margin-top: 3px;
	}
	.monthly-label-day {
		color: #70757a;
		font-size: 12px;
		font-weight: 500;
	}

	/* custom */
	.v-calendar-weekly__day {
    	padding: 0px 4px 4px 4px;
	}
	.v-calendar-weekly__day-label {
    	margin: 4px auto auto auto;
		position: unset !important;
		width: 24px;
    	height: 24px;
		line-height: 22px;
	}
	.v-calendar-weekly__day-label:hover {
		background: rgba(0,0,0,0.04);
		text-decoration: none;
	}
	.v-calendar-weekly__day.v-present .v-calendar-weekly__day-label {
    	border: 1px solid currentColor;
		background-color: currentColor;
		color: white;
	}
	.v-calendar-weekly__day-label, .primary--text > .monthly-label-day {
		color: white;
	}
	.v-calendar-weekly__head-weekday, .v-calendar-weekly__day-month {
		text-transform: uppercase;
		text-align: center;
		color: #70757a !important;
		font-size: 11px;
		font-weight: 500;
		line-height: 20px;
		padding-top: 4px;
	}
	.v-calendar-daily_head-weekday {
		color: #70757a;
		font-size: 11px;
		font-weight: 500;
		letter-spacing: .8px;
		margin-left: 0;
		margin-top: 8px;
		text-indent: .8px;
		text-transform: uppercase;
		text-align: center;
	}
	.v-calendar-daily_head-day-label {
		color: #70757a;
		font-size: 26px;
		letter-spacing: -2.6px;
		text-indent: -2.6px;
		font-variant: tabular-nums;
		-webkit-font-feature-settings: "tnum" 1;
		font-feature-settings: "tnum" 1;
		-webkit-border-radius: 100%;
		border-radius: 100%;
		color: #3c4043;
		font-family: 'Google Sans',Roboto,Arial,sans-serif;
		line-height: 46px;
		height: 46px;
		margin-left: auto;
		margin-right: auto;
		margin-top: -8px;
		width: 46px;
		display: -webkit-box;
		display: -moz-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-flex-direction: column;
		flex-direction: column;
		-webkit-justify-content: center;
		justify-content: center;
		cursor: pointer;
		position: relative;
		outline: none;
		text-align: center;
		font-weight: 400;
		padding: 0;
	}
	.v-calendar-daily_head-day-label:hover {
		text-decoration: none;
		background-color: #f1f3f4;
		border-bottom: none;
		padding-bottom: 0;
	}
	.v-calendar-daily__interval-text {
		color: #70757a !important;
	}
	.open-nav .v-calendar-daily__head {
		width: calc(100% - 298px);
	}
	.v-calendar-daily__head {
		position: fixed;
		width: calc(100% - 8px);
		background: white;
		z-index: 2;
	}
	.v-calendar-daily__body {
    	padding-top: 70px;
	}
</style>